// Shown by the root error boundary, most often when Strapi is waking up and the
// page has no cached copy yet. A reload is enough once Strapi answers.
export default function Error() {
  return (
    <div className="container mx-auto p-8 text-center">
      <h2 className="text-1.5 leading-1.5 font-bold mb-1">We&apos;ll be right back</h2>
      <p className="mb-1">
        The page is taking a moment to load. Please try again shortly, or call (888) 612-1308.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="uppercase font-bold underline underline-offset-1/4"
      >
        Try again
      </button>
    </div>
  );
}
